const initialState = [
  // {
  //   id: "team-xyz-plan",
  //   amount: 40000,
  //   interval: "year",
  //   nickname: "Team XYZ",
  //   trial_period_days: 60,
  //   current_plan: true
  // },
  // {
  //   id: "anotherplan",
  //   amount: 800,
  //   interval: "month",
  //   nickname: "Monthly",
  //   trial_period_days: 60,
  //   current_plan: false
  // }
]

function plans(state = initialState, action) {
  switch (action.type) {
    case "GET_PLANS_SUCCESS":
      return action.data
    case "SET_CURRENT_PLAN":
      return state.map(plan => {
        return {
          ...plan,
          current_plan: plan.id == action.product_identifier
        }
      })

    default:
      return state
  }
}

export default plans



// WEBPACK FOOTER //
// ./src/models/plans.js